import { groq } from "next-sanity";

export const maintenancePageQuery = groq`{
  "maintenancePage": *[_type == "maintenancePage"][0] {
    headline,
    isActive,
    backgroundPattern->{
      pattern
    },
  },
  "socials": *[_type == "socials"][-1]{
    socialMedia
  }
}`;
